module.exports = __webpack_public_path__ + "img/Monstera.0f4462db.png";